// Constants for localStorage keys
export const KEYS = {
  LOGIN_TOKEN_STORE_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',
  TOKEN_TYPE_KEY: 'token_type',
} as const;
